'use client';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  hasPrevPage?: boolean;
  hasNextPage?: boolean;
  prevPage?: number;
  nextPage?: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export default function Pagination({ currentPage, totalPages, hasPrevPage, hasNextPage, prevPage, nextPage, onPageChange, className = '' }: PaginationProps) {
  const isFirstPage = !hasPrevPage;
  const isLastPage = !hasNextPage;

  return (
    <div className={`flex items-center justify-center gap-4 ${className}`}>
      {/* Previous Button */}
      <button onClick={() => onPageChange(prevPage || currentPage - 1)} disabled={isFirstPage} className={`px-4 py-2 rounded-lg border transition-colors ${isFirstPage ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 cursor-pointer'}`}>
        <div className="flex items-center gap-2">
          <span>←</span>
          <span>Previous</span>
        </div>
      </button>

      {/* Page Indicator */}
      <div className="text-gray-700 font-medium">
        Page {currentPage} of {totalPages}
      </div>

      {/* Next Button */}
      <button onClick={() => onPageChange(nextPage || currentPage + 1)} disabled={isLastPage} className={`px-4 py-2 rounded-lg border transition-colors ${isLastPage ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50 cursor-pointer'}`}>
        <div className="flex items-center gap-2">
          <span>Next</span>
          <span>→</span>
        </div>
      </button>
    </div>
  );
}
